import React from "react";
import { Link } from "@/components/common/Link";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
export default function OurFamilyHeritage() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  return <section id="our-family-heritage" className="bg-background py-24 lg:py-32 overflow-hidden">
      <div className="container mx-auto px-4 md:px-6">
        <div ref={ref} className={cn("grid grid-cols-1 lg:grid-cols-12 gap-8 items-center transition-all duration-1000 ease-out", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12")}>
          {}
          <div className="lg:col-span-6 relative z-10">
            <div className="relative w-full shadow-2xl rounded-sm overflow-hidden">
              <AspectRatio ratio={3 / 4}>
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1558956/img/9.png" alt="Juan Orzuna preparing authentic mole with traditional clay pots" className="object-cover w-full h-full hover:scale-105 transition-transform duration-700 ease-in-out" />
              </AspectRatio>
              {}
              <div className="absolute -bottom-6 -left-6 w-24 h-24 bg-accent/30 rounded-full blur-2xl -z-10" />
              <div className="absolute -top-6 -right-6 w-32 h-32 bg-primary/20 rounded-full blur-3xl -z-10" />
            </div>
          </div>

          {}
          {}
          <div className="lg:col-span-6 lg:-ml-24 relative z-20 mt-8 lg:mt-0">
            <div className="bg-background/95 backdrop-blur-sm p-8 md:p-12 lg:p-16 shadow-xl border-l-4 border-primary/60 rounded-r-sm">
              <div className="space-y-6">
                <div className="space-y-2">
                  <span className="text-primary font-medium tracking-widest uppercase text-sm">ESTABLISADOS EN INDIANAPOLIS</span>
                  <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl text-foreground leading-tight">Un Legado de Sabor y Familia</h2>
                </div>

                <p className="text-muted-foreground text-lg leading-relaxed">En Banquetes Orzuna, nuestra cocina es una extensión de nuestro hogar. Fundados en la creencia de que los mejores recuerdos se crean alrededor de la mesa, llevamos generaciones de tradición culinaria mexicana a Indianápolis.</p>

                <p className="text-muted-foreground text-lg leading-relaxed">Cada platillo que servimos —desde nuestra birria cocinada a fuego lento hasta nuestro rico y complejo mole— se prepara con la misma paciencia y amor que me enseñó mi abuela. No solo atendemos eventos; compartimos un pedazo de nuestra herencia, asegurándonos de que tu celebración se sienta tan cálida y acogedora como una reunión familiar.</p>

                <div className="pt-8 mt-4 border-t border-border/40">
                  <div className="flex flex-col gap-1">
                    <span className="font-serif text-3xl md:text-4xl italic text-foreground transform -rotate-2 origin-left">Laura Orzuna</span>
                    <span className="text-xs text-muted-foreground uppercase tracking-widest font-medium mt-2">COCINERA PRINCIPAL</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}